// extracted by mini-css-extract-plugin
module.exports = {"logoLink":"iC","logoWrapper":"iD"};